<top-banner variant="logo"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Live Sessions"
              icon="fas fa-list"
              buttonLabel="{{ isMapView ? 'LIST VIEW' : 'MAP VIEW' }}"
              buttonIcon="fas fa-map-marker-alt"
              (buttonClick)="toggleSessionsView()">
          </card-section-header>

          <!-- MAP VIEW -->
          <ng-container *ngIf="isMapView">
            <div class="row">
              <div class="col-md-9">
                <select class="form-control my-3" style="width: auto" (change)="mapViewChange($event.target.value)">
                  <option>Worker Location View</option>
                  <option>Weather View</option>
                </select>
              </div>
              <div class="col-md-12" *ngIf="isWeatherView">
                <iframe
                  [src]="meteoBlueUrl | safe"
                  frameborder="0"
                  scrolling="NO"
                  allowtransparency="true"
                  sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                  style="width: 100%; height: 720px"
                ></iframe>
                <div>
                  <a href="https://www.meteoblue.com/en/weather/maps/index?utm_source=weather_widget&utm_medium=linkus&utm_content=map&utm_campaign=Weather%2BWidget" target="_blank rel='noreferrer'"
                    >meteoblue</a
                  >
                </div>
              </div>
              <div class="col-md-12" *ngIf="!isWeatherView">
                <agm-map
                  class="full-page-map"
                  [latitude]="defaultLat"
                  [longitude]="defaultLng"
                  [fitBounds]="latLngBounds"
                  [zoom]="defaultZoom"
                  [maxZoom]="maxZoom"
                  [fullscreenControl]="true"
                  [mapTypeControl]="true"
                  (mapReady)="mapReady($event)"
                  (boundsChange)="boundsChange($event)"
                >
                  <agm-marker
                    *ngFor="let m of markers; let i = index"
                    (markerClick)="clickedMarker(m.session, i)"
                    [latitude]="m.lat"
                    [longitude]="m.lng"
                    [markerDraggable]="m.draggable"
                    [iconUrl]="m.iconUrl"
                  ></agm-marker>
                </agm-map>
              </div>
            </div>
          </ng-container>

          <!-- LIST VIEW -->
          <ng-container *ngIf="!isMapView">
            <div class="row">
              <div class="col-md-12">
                <div class="filter-flex-row">
                  <div>
                    <label>Worker (name or login)</label>
                    <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'worker')"></text-filter-box>
                  </div>
                  <div>
                    <label>Company</label>
                    <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'company')"></text-filter-box>
                  </div>
                  <div>
                    <label>Site</label>
                    <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event, 'site')"></text-filter-box>
                  </div>
                  <div>
                    <label>Session Type</label>
                    <p-dropdown
                      class="form-control squareDropdown"
                      [options]="sessionTypes"
                      optionLabel="label"
                      (onChange)="onSessionTypeChanged($event)"
                      tabindex="1"
                      [tabindex]="-1"
                      (keydown.enter)="toggleDropdown($event)"
                      (keydown.space)="toggleDropdown($event)">
                    </p-dropdown>
                  </div>
                  <div *ngIf="isFilterLoading" class="small-spinner">
                    <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                  </div>
                  <filter-toggle-group
                    label="Expected Check-Off Time"
                    [options]="checkOffTimeButtons"
                    [value]="filters.checkOffTime"
                    (valueChange)="setCheckOffTimeFilter($event)">
                  </filter-toggle-group>
                  <filter-toggle-group
                    label="Waypoint"
                    [options]="waypointButtons"
                    [value]="filters.waypoint"
                    (valueChange)="setWaypointFilter($event)">
                  </filter-toggle-group>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 d-flex justify-content-end">
                <filter-summary-display [items]="activeFiltersSummary"></filter-summary-display>
                <table-action-bar
                  (toggleColumns)="columnOptionsSidebarVisible = true">
                  <button *ngIf="isExpanded" [disabled]="!canExpand" type="button" class="btn btn-link btn-secondary btn-sm ml-3" (click)="toggleExpandAllRows(false)">
                    <span><i class="fa fa-compress" aria-hidden="true"></i></span>
                    Collapse Additional Rows
                  </button>
                  <button *ngIf="!isExpanded" [disabled]="!canExpand" type="button" class="btn btn-link btn-secondary btn-sm ml-3" (click)="toggleExpandAllRows(true)">
                    <span><i class="fa fa-expand" aria-hidden="true"></i></span>
                    Expand Additional Rows
                  </button>
                </table-action-bar>
              </div>

              <div class="col-md-12">
                <p-table
                  [value]="liveSessionsMainWorkerListFiltered"
                  [dataKey]="'id'"
                  [expandedRowKeys]="expandKeys"
                  [autoLayout]="true"
                  (onSort)="customSort($event)"
                  [sortField]="defaultSortField"
                  [sortOrder]="defaultSortOrder"
                  [lazy]="true"
                >
                  <ng-template pTemplate="header">
                    <tr class="no-wrap-headers">
                      <th></th>
                      <th [pSortableColumn]="'startTime'">Start Time <p-sortIcon [field]="'startTime'"></p-sortIcon></th>
                      <th>Worker</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Company')">Company</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Phone')">Phone</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Guests')">Guests</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Site')" [pSortableColumn]="'s.name'">Site <p-sortIcon [field]="'s.name'"></p-sortIcon></th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Asset')">Asset</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Work Order')">Work Order ID</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Work Order')">Description</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Reason')">Reason</th>
                      <th>Waypoint</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Expected Check-Off Time')">Expected Check-Off Time</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Last Check')">Last Check</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Comments')">Comments</th>
                      <th *ngIf="tableOptions.visibleColumns.includes('Interval')">Interval</th>
                      <th></th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-expanded="expanded" let-liveSession>
                    <tr [pSelectableRow]="liveSession" [ngClass]="getMainRowClass(liveSession, expanded)">
                      <!-- Expand row toggle -->
                      <td>
                        <a href="#" *ngIf="liveSession.addWorkers?.length" [pRowToggler]="liveSession">
                          <i [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                        </a>
                      </td>
                      <!-- table row template -->
                      <ng-template *ngTemplateOutlet="tableRowTemplate; context: { $implicit: liveSession }"></ng-template>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="rowexpansion" let-liveSession>
                    <tr *ngFor="let addtionalSession of liveSession.addWorkers; let i = index" class="sub-row" [ngClass]="getAdditionalWorkerRowClass(i, liveSession.addWorkers)">
                      <td></td>
                      <!-- table row template -->
                      <ng-template *ngTemplateOutlet="tableRowTemplate; context: { $implicit: addtionalSession }"></ng-template>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="14">No live sessions found matching filters</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- the rows of the table -->
<ng-template #tableRowTemplate let-liveSession>
  <!-- start time -->
  <td><date-friendly [value]="liveSession.startTime"></date-friendly></td>

  <!-- user -->
  <td>
    {{ liveSession.fullName }} ({{ liveSession.login }})
    <br />
    <ng-container *ngIf="liveSession.addWorkers?.length"> + {{ liveSession.addWorkers?.length }} {{ liveSession.addWorkers?.length > 1 ? 'others' : 'other' }} </ng-container>
  </td>

  <!-- company name -->
  <td *ngIf="tableOptions.visibleColumns.includes('Company')">{{ liveSession.maintenanceName }}</td>

  <!-- phone number -->
  <td *ngIf="tableOptions.visibleColumns.includes('Phone')">{{ liveSession.phoneNumber }}</td>

  <!-- Guests -->
  <td *ngIf="tableOptions.visibleColumns.includes('Guests')">
    <span *ngIf="liveSession.guestCount > 0">{{ liveSession.guestCount }}</span>
    <span *ngIf="liveSession.guestCount < 1">N/A</span>
  </td>

  <!-- site name -->
  <td *ngIf="tableOptions.visibleColumns.includes('Site')">{{ liveSession.site }}</td>

  <!-- Work Order session with asset // site session -->
  <ng-container *ngIf="tableOptions.visibleColumns.includes('Asset')">
    <td *ngIf="liveSession.workOrderId!== null">
      {{ liveSession.assetName }}
    </td>
    <td *ngIf="liveSession.workOrderId === null">N/A</td>
  </ng-container>

  <!-- Work Order session // Site session -->
  <ng-container *ngIf="tableOptions.visibleColumns.includes('Work Order')">
    <td *ngIf="liveSession.workOrderId!== null">
      {{ liveSession.workOrderId }}
    </td>
    <td *ngIf="liveSession.workOrderId=== null">
      N/A
    </td>
  </ng-container>
  <ng-container *ngIf="tableOptions.visibleColumns.includes('Work Order')">
    <td *ngIf="liveSession.workOrderId!== null">
      {{ liveSession.workOrderDescription }}
    </td>
    <td *ngIf="liveSession.workOrderId=== null">
      <span class="badge badge-pill badge-primary">Site Session</span>
    </td>
  </ng-container>

  <!-- User check on notes -->
  <td *ngIf="tableOptions.visibleColumns.includes('Reason')">{{ liveSession.reason }}</td>

  <!-- Last health check status -->
  <td>
    <span [class]="liveSession.pillClass">{{ liveSession.pillText }}</span>
  </td>

  <td *ngIf="tableOptions.visibleColumns.includes('Expected Check-Off Time')">
    <ng-container *ngIf="liveSession.expectedCheckOffTime; else noEcot">
      <i *ngIf="liveSession.ecotOverdue" class="fa fa-exclamation-triangle text-white mr-1" aria-hidden="true" title="Expected check-off overdue"></i>
      <date-friendly [value]="liveSession.expectedCheckOffTime"></date-friendly>
    </ng-container>
    <ng-template #noEcot>
      <span>N/A</span>
    </ng-template>
  </td>

  <!-- Last health check time -->
  <td *ngIf="tableOptions.visibleColumns.includes('Last Check')">
    <date-friendly [value]="liveSession.lastUserSessionHealthCheckTime"></date-friendly>
  </td>

  <!-- Comments -->
  <td *ngIf="tableOptions.visibleColumns.includes('Comments')">
    <div class="text-area">
      <textarea type="text" class="form-control with-autoresize" appTextareaAutoresize
        [(ngModel)]="liveSession.notes"
        (input)="onTextChange($event, liveSession)">
      </textarea>
    </div>
  </td>

  <!-- Site health check interval -->
  <ng-container *ngIf="tableOptions.visibleColumns.includes('Interval')">
    <td *ngIf="liveSession.healthCheckInterval">{{ liveSession.healthCheckInterval }} mins</td>
    <td *ngIf="!liveSession.healthCheckInterval">N/A</td>
  </ng-container>

  <td class="button-link-wrapper">
    <span class="badge badge-pill" style="cursor: pointer;" (click)="clickedMarker(liveSession)">details</span>
  </td>
</ng-template>

<!-- Map marker click popup dialog-->
<p-dialog header="Active Worker" [(visible)]="selectedWorkerSessionModal"
          [dismissableMask]="true" modal="true" [baseZIndex]="1000000"
          [style]="{'width': '90vw', 'max-width': '1000px'}"
          [draggable]="false"
          [blockScroll]="true"
          [contentStyle]="{'overflow-y': 'auto', 'overflow-x': 'hidden','max-height': '80vh','min-height':'250px'}"
          (onHide)="disableEditing()">
  <div class="row">
    <div class="col-md-6">
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <strong>User:</strong> {{ selectedLiveSession?.fullName }}
          (<username-display [userName]="selectedLiveSession?.login"></username-display>)
        </li>
        <li class="list-group-item"><strong>Phone:</strong> {{ selectedLiveSession?.phoneNumber }}</li>
        <li class="list-group-item"><strong>Company:</strong> {{ selectedLiveSession?.maintenanceName }}</li>
        <li class="list-group-item"><strong>Site:</strong> {{ selectedLiveSession?.site }}</li>
        <li class="list-group-item" *ngIf="selectedLiveSession?.workOrderId !== null">
          <strong>Work Order:</strong> #{{ selectedLiveSession.workOrderId }}
          <div class="button-link-wrapper">
            <button type="button" class="btn btn-primary btn-link" (click)="goToWorkOrder(selectedLiveSession)">
              go to work order
              <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
            </button>
          </div>
        </li>
        <li class="list-group-item" *ngIf="selectedLiveSession?.workOrderId !== null">
          <strong>Asset:</strong> {{ selectedLiveSession.assetName }}
        </li>
        <li class="list-group-item" *ngIf="selectedLiveSession?.workOrderId === null">
          <strong>Site Session</strong>
        </li>
        <li *ngIf="selectedLiveSession?.guestCount" class="list-group-item"><strong>Guests:</strong> {{ selectedLiveSession?.guestCount }}</li>
      </ul>
    </div>
    <div class="col-md-6">
      <ul class="list-group list-group-flush">
        <li class="list-group-item"><strong>Reason:</strong> {{ selectedLiveSession?.reason }}</li>
        <li class="list-group-item"><strong>Start:</strong> {{ selectedLiveSession?.startTime | date : 'E d MMM yyyy HH:mm' }}</li>
        <li *ngIf="selectedLiveSession?.healthCheckInterval" class="list-group-item">
          <strong>Check Interval:</strong> {{ selectedLiveSession?.healthCheckInterval }} mins
        </li>
        <li *ngIf="!selectedLiveSession?.healthCheckInterval" class="list-group-item"><strong>Check Interval:</strong> N/A</li>
        <li class="list-group-item">
          <strong>Last Check:</strong>
          {{ selectedLiveSession?.lastUserSessionHealthCheckTime | date : 'E d MMM yyyy HH:mm' }}
        </li>
        <li class="list-group-item">
          <div class="d-flex align-items-center">
            <div>
              <strong>Expected Check-Off Time:</strong>
              <span>{{ selectedLiveSession?.expectedCheckOffTime | date : 'E d MMM yyyy HH:mm' }}</span>
            </div>

            <div *ngIf="!isEditing; else editableDate" class="ml-3">
              <button class="btn btn-primary btn-link" (click)="enableEditing()">Edit</button>
            </div>

            <ng-template #editableDate>
              <div class="d-flex align-items-center ml-3">
                <p-calendar [(ngModel)]="selectedDateTime" [showTime]="true" hourFormat="24" timeOnly="true" placeholder="HH:mm"
                  [closeOnDateSelect]="false" class="timepicker-input">
                </p-calendar>
                <button class="btn btn-primary btn-link ml-2" (click)="updateCheckOffTime()">Save</button>
                <button class="btn btn-secondary btn-link" (click)="disableEditing()">Cancel</button>
              </div>
            </ng-template>
          </div>
        </li>
        <li *ngIf="selectedLiveSession?.outsideGeoFence" class="list-group-item"><strong>Location:</strong> Outside Site geofence boundary</li>
        <li *ngIf="selectedLiveSession?.placeholderLocation" class="list-group-item"><strong>Location:</strong> Unknown</li>
        <li *ngIf="!selectedLiveSession?.placeholderLocation && selectedLiveSession?.locationUnknown" class="list-group-item"><strong>Location:</strong> Unknown</li>
        <ng-container *ngIf="selectedLiveSession?.locationConfirmed">
          <li class="list-group-item"><strong>Location:</strong> Confirmed <a href="javascript:void(0)" (click)="getWhat3Words(selectedLiveSession)"><img src="./assets/img/logos/w3w_Symbol_RGB_Red.svg" width="33" height="33" alt="What3words"/></a></li>
          <li class="list-group-item"><strong>Location Updated At:</strong>{{ selectedLiveSession?.locationUpdatedTime | date : 'E d MMM yyyy HH:mm' }}</li>
        </ng-container>
      </ul>
    </div>
      <div class="col-md-12">
        <div class="check-out__main-content-dflex">
          <button *ngIf="showCheckOffButtons()" type="button"
            class="btn btn-primary btn-link check-out__btn"
            (click)="checkout(selectedLiveSession, 'CLOSED')">Check Out - Close</button>
          <button *ngIf="showCheckOffButtons()" type="button"
            class="btn btn-primary btn-link check-out__btn"
            (click)="checkout(selectedLiveSession, 'SUSPENDED')">Check
            Out - Suspend</button>
          <button *ngIf="showCheckOffButtons()" type="button"
            class="btn btn-primary btn-link check-out__btn"
            (click)="checkout(selectedLiveSession, 'SURRENDERED')">Check
            Out - Surrender</button>
          <button *ngIf="!sessionOwner && selectedLiveSession?.workOrderId !== null" type="button"
            class="btn btn-primary btn-link check-out__btn"
            (click)="checkout(selectedLiveSession, 'SUSPENDED')">Check
            Out Worker</button>
          <button *ngIf="selectedLiveSession?.workOrderId === null" type="button"
          class="btn btn-primary btn-link check-out__btn"
            (click)="checkout(selectedLiveSession, 'SUSPENDED')">Check Out Site Session</button>
        </div>
      </div>
  </div>
  <div class="row" *ngIf="selectedLiveSession && selectedLiveSession.addWorkers?.length">
    <div class="col-md-12">
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <strong>Additional Workers:</strong><br />
          <ng-container *ngFor="let worker of selectedLiveSession.addWorkers; index as i">
            {{ worker.fullName }} (<username-display [userName]="worker.login"></username-display>)<span *ngIf="i + 1 < selectedLiveSession.addWorkers.length">, </span>
          </ng-container>
        </li>
      </ul>
    </div>
  </div>
</p-dialog>

<!-- column options sidebar -->
<p-sidebar [(visible)]="columnOptionsSidebarVisible" position="right" [baseZIndex]="900">
  <h6 class="text-primary my-4">Column Options</h6>
  <label>Show:</label>
  <ng-container *ngFor="let col of togglableColumns">
    <div class="form-group">
      <p-checkbox name="togglableColumns" [value]="col.displayName" [(ngModel)]="tableOptions.visibleColumns" (ngModelChange)="saveTableOptions()" [label]="col.displayName"></p-checkbox>
    </div>
  </ng-container>
  <button (click)="resetColumnOptions()" class="mt-4 btn btn-round btn-default btn-simple btn-block">reset to default</button>
</p-sidebar>
